import { service } from '@ember/service';
import Component from '@glimmer/component';

import type IntlService from 'ember-intl/services/intl';
import type { IBvTableBaseCellArgs } from 'volta/components/cell/base-cell';
import type ImportHisto from 'volta/models/import-histo';
import type StoreService from 'volta/services/store';

export default class ImportResultCell extends Component<IBvTableBaseCellArgs> {
  @service intl!: IntlService;
  @service store!: StoreService;

  get importHisto() {
    return this.args.row.rowValue as ImportHisto | undefined;
  }

  downloadFile = (url?: string) => {
    url && this.store.downloadFile(url);
  };
}
